import { Flow } from "@thive/fddm-types";
import { ConsolidationFlow } from "./types";

export const isConsolidationFlowType = (type: Flow['type']): type is ConsolidationFlow['type'] =>
  type === 'CONSOLIDATION_STORAGE' || type === 'CONSOLIDATION_RETRIEVAL';
